import React, { useState, useEffect } from 'react';
import './DailPad.css'; // Add your CSS file for styling
import axios from 'axios';
import { useParams, useLocation } from 'react-router-dom';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { encryptWithManagedIV } from '../../utils/DecryptingModule';

export default function SmsInvite() {
  const { room } = useVideoContext();
  const { search, state } = useLocation();
  const [input, setInput] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { URLRoomName } = useParams<{ URLRoomName?: string }>();
  const [roomName, setRoomName] = useState<string>('');
  const [UserName, setUserName] = useState<string>('');
  useEffect(() => {
    if (URLRoomName) {
      setRoomName(URLRoomName);
      if (state) {
        const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
        const providerName = (state as { state: { providerName: string } }).state.providerName;
        setUserName(providerName);
      }
    }
  }, [URLRoomName]);

  const handleDigitClick = (digit: string) => {
    setInput(prevInput => prevInput + digit);
  };

  const handleClearClick = () => {
    setInput('');
  };

  const handlePlusClick = () => {
    setInput(prevInput => prevInput + '+');
  };

  const handleHashClick = () => {
    setInput(prevInput => prevInput + '#');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9+]/g, ''); // Allow only numbers, plus, and hash

    setInput(sanitizedValue);
  };

  const handleBackspaceClick = () => {
    setInput(prevInput => prevInput.slice(0, -1));
  };

  const Sms = async () => {
    if (input.length === 0) {
      alert('Please enter a valid number');
    } else {
      const encryptionKeyBase64 = 'T543oUJD9RzlE7YzlGesLpqCL988CV1Zavj7hvjpTQw='; // Your encryption key

      // let abcd;
      const ContactPhoneNumber = (state as { state: { ContactPhoneNumber: string } }).state.ContactPhoneNumber;
      const RecordId = (state as { state: { RecordId: string } }).state.RecordId;
      const ContactName = (state as { state: { ContactName: string } }).state.ContactName;
      const ProviderId = (state as { state: { ProviderId: string } }).state.ProviderId;
      const Type = (state as { state: { Type: string } }).state.Type;
      const providerName = (state as { state: { providerName: string } }).state.providerName;
      const data1 = {
        RecordId: RecordId,
        ContactName: ContactName,
        ContactPhoneNumber: input,
        ProviderId: ProviderId,
        providerName: providerName,
        Type: 'Patient',
      };
      console.log('data1', data1);
      //console.log(data1);
      const abcd = await encryptWithManagedIV(data1, encryptionKeyBase64);
      //console.log(abcd, 'abcd');
      // encryptWithManagedIV(state.state, encryptionKeyBase64)
      //     .then(encryptedData => {
      //         abcd = encryptedData
      //         //console.log('Encrypted Data:', encryptedData);
      //         abcd = encryptedData
      //     })
      //     .catch(error => {
      //         console.error('Error:', error);
      //     });

      const response = await axios.post('https://avserver.jobsitecare.com/sms', {
        number: input,
        origin: window.location.origin,
        link: abcd,
        participantname: input,
        roomname: roomName,
        username: UserName,
      });
      console.log('response', response);
      if (response.status) {
        alert('SMS has been sent successfully');
      }
      const btn = document.getElementById('closebutton')?.click();
    }
  };
  const Participants = async () => {
    if (room) {
      //console.log(room);

      const Data = Array.from(room?.participants.values(), p => ({
        participant: p.identity,
        dominantSpeakerStartTime: 0,
      }));
      //console.log(Data);
    }
  };
  const Call = async () => {
    if (input.length === 0) {
      alert('Please enter a valid number');
    } else {
      const response = await axios.post('https://avserver.jobsitecare.com/call', {
        number: input,
        participantname: input,
        roomname: roomName,
      });
      //console.log(response);
      if (response.status) {
        alert('Call Has Been Dialed Successfully');
      }
      const btn = document.getElementById('closebutton')?.click();
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Capture global keyboard events
  // useEffect(() => {
  //   const handleGlobalKeyPress = (e: KeyboardEvent) => {
  //     const key = e.key;
  //     if (/[0-9+]/.test(key)) {
  //       setInput(prevInput => prevInput + key);
  //     } else if (key === 'Enter') {
  //       // Handle Enter key press (e.g., trigger SMS or Call)
  //       // You can add your logic here
  //     } else if (key === 'Backspace') {
  //       // Handle Backspace key press to erase one character
  //       handleBackspaceClick();
  //     }
  //   };

  //   document.addEventListener('keydown', handleGlobalKeyPress);

  //   return () => {
  //     document.removeEventListener('keydown', handleGlobalKeyPress);
  //   };
  // }, []);

  return (
    <div className="dialpad">
      <input
        className="input-display"
        type="text"
        value={input}
        onChange={handleInputChange}
        placeholder="+1 555-555-5555"
      />
      <button onClick={handleBackspaceClick} className="backspace">
        <img src="https://www.computerhope.com/jargon/b/backspace-icon.png" alt="we" />
      </button>

      <div className="row">
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('1')}>1</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('2')}>2</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('3')}>3</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('4')}>4</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('5')}>5</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('6')}>6</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('7')}>7</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('8')}>8</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('9')}>9</button>
        </div>
        <div className="col-sm-4">
          <button onClick={handleClearClick}>C</button>
        </div>
        <div className="col-sm-4">
          <button onClick={() => handleDigitClick('0')}>0</button>
        </div>
        <div className="col-sm-4">
          <button onClick={handlePlusClick}>+</button>
        </div>
        <div className="col-sm-12">
          <button onClick={Sms} className="callbtn">
            {' '}
            Send{' '}
          </button>
        </div>
      </div>

      {/* 
      <div className="button-container">
        <div className="button-container">
          <div className="row">
          </div>
          <div className="row">          
          </div>
          <div className="row">         
          </div>
          <div className="row">
          </div>
          <div className="row"></div>
          <div className="row buttonssms">
             <button onClick={Participants} className="callbtn">
              participants
            </button> 
          </div>
        </div>
      </div> */}
    </div>
  );
}
